import { LoaderCircle } from "lucide-react";
import React, { useCallback, useState } from "react";
import { useAppSelector } from "@/store/hooks";
import { executeGraphQLMutation } from "@/utils/helper/graphql-helper";
import { updateQuickReorder } from "@/graphql/mutations";
import { QuickReorder as QuickReorderTypes } from "@/types/AppTypes";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import UpdateBuyerProductStockTableWrapper from "@/components/updateBuyerProductStockTable/UpdateBuyerProductStockTableWrapper";

export default function UpdateBuyerProductStock() {
  const { id } = useParams<{ id: string }>();
  const { categories } = useAppSelector((state) => state.app);
  const [stockLoading, setStockLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleStockChange = useCallback(
    async (product: QuickReorderTypes, newStock: number) => {
      const updatedQuickReorder = await executeGraphQLMutation({
        query: updateQuickReorder,
        variables: {
          input: {
            id: product?.id,
            stock: newStock,
            updated_at: new Date().toISOString(),
          },
        },
        setLoading: setStockLoading,
      });
      if (updatedQuickReorder) {
        toast.success("Product stock updated successfully");
      }
    },
    []
  );

  return (
    <UpdateBuyerProductStockTableWrapper
      userId={id || ""}
      categories={categories}
      handleStockUpdate={handleStockChange}
      stockLoading={stockLoading}
      dialogOpen={dialogOpen}
      setDialogOpen={setDialogOpen}
    />
  );
}
